import { trackPartnerStoreCardClicked } from '../actions/partners'
import { VS_LINK_ORDER_TAKING } from '../constants'
import { formatPageName } from './formatPageName'
import { formatPathname } from './formatPathname'

export const selectPartnerStore = (
  dispatch,
  interactiveState,
  globalActions,
  _e,
  meta
) => {
  const {
    selectedStore,
    cardStyle: card_style,
    cardsQuantity: cards_quantity,
    position,
    screen_name,
    vendorId,
    title: menu_category,
    accountId,
  } = meta
  dispatch(
    trackPartnerStoreCardClicked({
      card_style,
      cards_quantity,
      position,
      screen_name,
      store_id: selectedStore.storeId,
      vendorId,
      referrer: interactiveState.globals.page.referrer,
    })
  )

  dispatch(
    globalActions.appActions.trackMenuInteraction({
      menu_category,
      menu_subcategory: selectedStore?.name,
      store_id: selectedStore.storeId,
      referrer: formatPathname(interactiveState?.page?.referrer),
      screen_name: formatPageName(screen_name),
      value_stream: VS_LINK_ORDER_TAKING,
    })
  )

  const redirectToHome = window.location.pathname !== '/cms/index/home'

  dispatch(
    globalActions.user.changeStore(
      {
        ...selectedStore,
        accountId,
      },
      redirectToHome
    )
  )
}
